export default (function () {
    const subcat = {
        initSliders() {
            const $slider = $('.js--subcategory-slider');
            if ($slider) {
                if ($slider.children().length > 6) {
                    $slider.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 6,
                        slidesToScroll: 1,
                        nextArrow: " <div class=\"js--subcategory_next subcategory__slider_btn subcategory__slider_btn--next\">\n" +
                            "            <svg class=\"subcategory__slider_btn_ico\">\n" +
                            "                <use xlink:href=\"/themes/onv100/img/symbol_sprite.svg#icon-arrow_btn_w\"></use>\n" +
                            "            </svg>\n" +
                            "        </div>",
                        prevArrow: "<div class=\"js--subcategory_prev subcategory__slider_btn subcategory__slider_btn--prev\">\n" +
                            "            <svg class=\"subcategory__slider_btn_ico\">\n" +
                            "                <use xlink:href=\"/themes/onv100/img/symbol_sprite.svg#icon-arrow_btn_w\"></use>\n" +
                            "            </svg>\n" +
                            "        </div>",
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                },
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    dots: true,
                                },
                            },
                        ],
                    });
                }
                $slider.show();
            }
        },
    };
    $(document).ready(() => {
        subcat.initSliders();
    });
}());
